export default {
  laya: 'Die digitale Lernplattform zum inklusiven Lernen',
  imprint: 'Impressum',
  privacy: 'Datenschutz'
}
